import { Pipe, PipeTransform } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { Observable, of } from 'rxjs';
import { MARKETPLACE_TRANSLOCO_SCOPE } from '../marketplace-transloco-scope';
import { ExtendedSubscriptionInterval } from './model/extended-subscription-interval';
import { SubscriptionIntervalDisplayMode } from './model/subscription-interval-display-mode';

@Pipe({
  name: 'subscriptionInterval'
})
export class SubscriptionIntervalPipe implements PipeTransform {
  constructor(private translocoService: TranslocoService) {}

  transform(value: ExtendedSubscriptionInterval | null, mode: SubscriptionIntervalDisplayMode): Observable<string> {
    if (value) {
      return this.translocoService.selectTranslate('product.subscriptionInterval.' + value + '.' + mode, {}, MARKETPLACE_TRANSLOCO_SCOPE);
    }
    return of('');
  }
}
